<template>
  <div class="entitlement_details">
    <b-row
      class="content-header"
    >
      <!-- Content Left -->
      <b-col
        class="content-header-left mb-2"
        cols="12"
        md="9"
      >
        <b-row class="breadcrumbs-top">
          <b-col cols="12">
            <h1 class="custom-header-title">
              {{ entitlement.stringID }} - {{ entitlement.name }}
            </h1>
            <p class="log_info">
              Created by {{ entitlement.createdBy ? entitlement.createdBy.name : '' }} on {{ entitlement.createdAt ? dateFormatWithTime(entitlement.createdAt) : '' }} <br>Last updated on {{ entitlement.updatedAt ? dateFormatWithTime(entitlement.updatedAt) : '' }}
            </p>
          </b-col>
        </b-row>
      </b-col>
      <b-col
        class="content-header-right text-md-right mb-1"
        md="3"
        cols="12"
      >
        <div class="user_block low-width">
          <b-dropdown
            variant="flat-primary"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >

            <template #button-content>
              <feather-icon
                icon="MoreHorizontalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>

            <b-dropdown-item
              v-if="canViewThisAction('update', 'Entitlement') && entitlement.status == 'redeemed'"
              @click="undoRedemption(entitlement._id)"
            >
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">Undo Redemption</span>
            </b-dropdown-item>

            <b-dropdown-item
              v-if="canViewThisAction('update', 'Entitlement') && entitlement.status == 'cancelled'"
              @click="markAsRedeemable(entitlement._id)"
            >
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">Mark as Redeemable</span>
            </b-dropdown-item>

            <b-dropdown-item
              v-if="canViewThisAction('update', 'Entitlement') && (entitlement.status == 'redeemable' || entitlement.status == 'cancelled')"
              @click="markAsRedeemed(entitlement._id)"
            >
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">Mark as Redeemed</span>
            </b-dropdown-item>

            <b-dropdown-item
              v-if="canViewThisAction('update', 'Entitlement') && entitlement.status == 'redeemable'"
              @click="markAsCancelled(entitlement._id)"
            >
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">Mark as Cancelled</span>
            </b-dropdown-item>

            <b-dropdown-item
              v-if="canViewThisAction('update', 'Entitlement')"
            >
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">Re-send Email</span>
            </b-dropdown-item>

            <b-dropdown-item
              v-if="canViewThisAction('update', 'Entitlement') && (entitlement.status == 'redeemable' || entitlement.status == 'expired')"
              id="toggle-btn"
              v-b-modal.modal-update-validuntil-all-entitlement
              @click="setEntitlement(entitlement)"
            >
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">Edit Validity</span>
            </b-dropdown-item>

            <b-dropdown-item
              v-if="canViewThisAction('update', 'Entitlement')"
              id="toggle-btn"
              v-b-modal.modal-update-remarks-all-entitlement
              @click="setEntitlementRemarks(entitlement)"
            >
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">Edit Internal Remarks</span>
            </b-dropdown-item>
          </b-dropdown>
        </div>
        <div class="user_block pr_stage_type">
          <div class="user_avatar" />
          <div class="user_info">
            <h6>Entitlement Status</h6>
            <h5 :class="`text-${resolveStatusVariant(entitlement.status)}`">
              {{ entitlement.status }}
            </h5>
          </div>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="6">
        <b-card
          header-tag="header"
          class=""
        >
          <div class="d-flex justify-content-between align-items-center w-100 header_part">
            <h5 class="mb-0">
              Entitlement Details
            </h5>
          </div>
          <b-table-simple
            borderless
            responsive
          >
            <b-tbody>
              <b-tr>
                <b-th width="230">
                  Entitlement
                </b-th>
                <b-td class="mt-50">
                  {{ entitlement.name }}
                </b-td>
              </b-tr>
              <b-tr>
                <b-th width="230">
                  Related File
                </b-th>
                <b-td class="mt-50">
                  <div
                    v-if="entitlement.fileID"
                    class="text-nowrap"
                  >
                    <b-button
                      v-if="canViewThisAction('show', 'File')"
                      v-ripple.400="'rgba(30, 30, 30, 0.15)'"
                      variant="link"
                      class="weight-600 align-middle detail-view-id"
                      :to="{ name: 'customers-files-show', params: { id: entitlement.fileID.fileID } }"
                    >
                      {{ entitlement.fileID.fileNo }}
                    </b-button>
                    <b-button
                      v-else
                      v-ripple.400="'rgba(30, 30, 30, 0.15)'"
                      variant="link"
                      class="text-bold align-middle detail-view-id not-button"
                    >
                      {{ entitlement.fileID.fileNo }}
                    </b-button>
                  </div>
                </b-td>
              </b-tr>
              <b-tr>
                <b-th width="230">
                  Entitlement Scheme
                </b-th>
                <b-td class="mt-50">
                  <div
                    v-if="entitlement.schemeID"
                    class="text-nowrap"
                  >
                    <b-button
                      v-if="canViewThisAction('show', 'EntitlementScheme')"
                      v-ripple.400="'rgba(30, 30, 30, 0.15)'"
                      variant="link"
                      class="weight-600 align-middle detail-view-id"
                      :to="{ name: 'products-schemes-show', params: { id: entitlement.schemeID ? entitlement.schemeID._id : '0' } }"
                    >
                      {{ entitlement.schemeID.name }}
                    </b-button>
                    <b-button
                      v-else
                      v-ripple.400="'rgba(30, 30, 30, 0.15)'"
                      variant="link"
                      class="text-bold align-middle detail-view-id not-button"
                    >
                      {{ entitlement.schemeID.name }}
                    </b-button>
                  </div>
                </b-td>
              </b-tr>
              <b-tr>
                <b-th width="230">
                  Entitlement Item Type
                </b-th>
                <b-td class="mt-50">
                  {{ entitlement.schemeItemID ? resolveTypeValue(entitlement.schemeItemID.type) : '' }}
                </b-td>
              </b-tr>
              <b-tr>
                <b-th width="230">
                  Validity
                </b-th>
                <b-td class="mt-50">
                  <div
                    v-if="entitlement.validUntil"
                    class="text-nowrap"
                  >
                    <span class="">{{ dateFormat(entitlement.validUntil) }}</span>
                  </div>
                  <div v-else>
                    -
                  </div>
                </b-td>
              </b-tr>
              <b-tr>
                <b-th width="230">
                  Paid Entitlement
                </b-th>
                <b-td class="mt-50">
                  {{ entitlement.isPaidEntitlement ? 'Yes' : 'No' }}
                </b-td>
              </b-tr>
            </b-tbody>
          </b-table-simple>
          <hr class="dividerHR">
          <b-table-simple
            borderless
            responsive
          >
            <b-tbody>
              <b-tr>
                <b-th width="230">
                  internal remarks
                </b-th>
                <b-td class="mt-50">
                  <span class="mt-50">
                    {{ entitlement.internalRemarks }}
                  </span>
                </b-td>
              </b-tr>
            </b-tbody>
          </b-table-simple>
        </b-card>
      </b-col>
    </b-row>

    <b-card
      title="Related to this Entitlement"
      class="p-2"
    >
      <b-card-text>
        <b-tabs
          class="purchaser-tabs"
          content-class="mt-2"
        >
          <b-tab
            v-if="canViewThisAction('read', 'ServiceRequest')"
            lazy
            title="Sales Order"
          />
          <b-tab
            v-if="canViewThisAction('read', 'ServiceRequest')"
            lazy
            title="Service Requests"
          />
          <b-tab
            v-if="canViewThisAction('read', 'InventoryItem')"
            lazy
            title="Inventory Item"
          />
        </b-tabs>
      </b-card-text>
    </b-card>

    <b-card
      header-tag="header"
    >
      <div class="d-flex justify-content-between align-items-center w-100 header_part">
        <h5 class="align-middle mr-auto">
          Selected Option
        </h5>
        <b-button
          variant="flat-primary"
          class="selected-option-edit-btn"
          :disabled="['expired', 'cancelled'].includes(entitlement.status)"
          @click="openEditSelectedOption"
        >
          <feather-icon
            icon="EditIcon"
            size="14"
            class="mr-50"
          />
          Edit
        </b-button>
      </div>

      <b-table-simple
        small
        responsive
        class="has_padding shadow-table"
      >
        <b-thead>
          <b-tr>
            <b-th>Inventory item Option</b-th>
            <b-th>Quantity</b-th>
            <b-th>Store</b-th>
          </b-tr>
        </b-thead>
        <b-tbody>
          <b-tr
            v-for="(inv, index) in entitlement.selectedOptions"
            :key="index"
          >
            <b-td>
              <div class="d-flex align-items-center">
                <img
                  :src="inv.inventoryItemId ? (inv.inventoryItemId.image ? inv.inventoryItemId.image : require('@/assets/images/placeholder/placeholder_image.png')) : require('@/assets/images/placeholder/placeholder_image.png')"
                  alt="item image"
                  class="mr-1"
                  style="width: 50px; height: 50px; object-fit: cover; border-radius: 5px; border: 1px solid #D2DCEA;"
                >
                <div class="item_name">
                  {{ inv.inventoryItemId ? inv.inventoryItemId.name : '' }}
                </div>
              </div>
            </b-td>
            <b-td>{{ inv.quantity }}</b-td>
            <b-td>{{ inv.store }}</b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>
      <div class="selected-option-footer d-flex justify-content-end align-items-center mt-2">
        <span class="redeem-timer mr-2">
          {{ formattedCountdown }}
        </span>

        <b-button
          variant="success"
          class="px-2"
          @click="proceedToRedeem"
        >
          <feather-icon
            icon="GiftIcon"
            size="16"
            class="mr-50"
          />
          Proceed to Redeem
        </b-button>
      </div>
    </b-card>

    <b-card
      class="mb-3 mt-3 p-2"
    >
      <b-row
        class="content-header"
      >
        <!-- Content Left -->
        <b-col
          class="content-header-left pb-2"
          cols="12"
          md="12"
        >
          <h4>
            <feather-icon
              icon="ListIcon"
              class="mr-50"
              size="16"
            />
            <span class="align-middle">Activity Logs</span>
          </h4>
        </b-col>
      </b-row>
      <app-timeline>
        <!-- FINANCIAL REPORT -->
        <app-timeline-item
          v-for="(opt, key) in entitlementDetailActivityLogs"
          :key="key"
          :variant="getVariant(key)"
        >

          <div class="d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0">
            <h6>{{ opt.title }}</h6>
            <small class="text-muted">{{ dateFormatWithTime(opt.time) }}</small>
          </div>
          <b-button
            v-if="opt.activityDetails && opt.activityDetails.length"
            v-b-toggle="'report-list-with-icon-' + key"
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            size="sm"
            variant="outline-primary"
          >
            Details
            <feather-icon
              icon="ChevronUpIcon"
              class="ml-50 when-open"
              size="16"
            />
            <feather-icon
              icon="ChevronDownIcon"
              class="ml-50 when-closed"
              size="16"
            />
          </b-button>
          <b-collapse
            v-if="opt.activityDetails && opt.activityDetails.length"
            :id="'report-list-with-icon-' + key"
          >
            <b-table-simple
              borderless
              responsive
            >
              <b-tbody>
                <b-tr
                  v-for="(activityDetail, activitykey) in opt.activityDetails"
                  :key="activitykey"
                >
                  <b-th style="width: 300px; max-width: 300px;">
                    {{ activityDetail.title }}
                  </b-th>
                  <b-td>{{ activityDetail.oldValue }}</b-td>
                  <b-td>{{ activityDetail.newValue }}</b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </b-collapse>
        </app-timeline-item>
      </app-timeline>
    </b-card>

    <b-modal
      id="modal-redemption-code"
      ref="redemption-code-modal"
      centered
      hide-footer
      modal-class="redemption-code-modal"
      no-close-on-backdrop
      @hide="redemptionCode = ['','','','','','','','']; redemptionCodeError = ''"
    >
      <template #modal-header>
        <button
          type="button"
          class="close"
          @click="$bvModal.hide('modal-redemption-code')"
        >
          ×
        </button>
      </template>
      <div class="text-center redemption-wrapper">

        <!-- Gift Icon -->
        <div class="gift-icon-wrapper">
          <feather-icon
            v-if="isExpired"
            icon="ClockIcon"
            size="80"
            class="clock-icon"
          />
          <feather-icon
            v-else
            icon="GiftIcon"
            size="80"
            class="gift-icon"
          />
        </div>

        <!-- Title -->
        <h3 class="redemption-title">
          {{ isExpired ? 'The redemption code is expired.' : 'Enter Redemption Code' }}
        </h3>
        <!-- Description -->
        <p class="redemption-description">
          {{ isExpired ? 'Please request a new redemption code from the customer.' : 'This code can be generated only by customer using their Nirvana SG customer app for verification purposes.' }}
        </p>

        <!-- Code Inputs -->
        <div class="redemption-code-group">
          <div
            v-for="(code, index) in redemptionCode"
            :key="index"
            class="code-wrapper"
          >
            <b-form-input
              v-model="redemptionCode[index]"
              maxlength="1"
              class="code-input"
              @paste="handlePaste"
              @input="handleInput(index, $event)"
            />

            <!-- Hyphen after 4th digit -->
            <span
              v-if="index === 3"
              class="divider"
            >
              —
            </span>
          </div>
        </div>
        <div
          v-if="redemptionCodeError"
          class="text-danger text-center mb-1"
          style="font-size: 13px;"
        >
          <feather-icon
            icon="AlertCircleIcon"
            size="14"
            class="mr-25"
          />
          {{ redemptionCodeError }}
        </div>

        <!-- Bottom Line -->
        <div class="bottom-line" />

        <!-- Buttons -->
        <div class="d-flex justify-content-center mt-2">
          <b-button
            variant="outline-primary"
            class="mr-1 px-2"
            @click="$bvModal.hide('modal-redemption-code')"
          >
            Cancel
          </b-button>

          <b-button
            variant="primary"
            class="px-2"
            :disabled="isExpired"
            @click="redeemEntitlement"
          >
            Redeem this Entitlement
          </b-button>
        </div>
      </div>
    </b-modal>
    <b-modal
      id="modal-edit-selected-option"
      ref="selected-code-modal"
      centered
      hide-footer
      modal-class="edit-selected-option-modal"
      title="Edit Selected Option"
    >
      <div class="inventory-option-list">
        <div
          v-for="(item, index) in inventoryOptions"
          :key="index"
          class="inventory-option-card"
          :class="{ active: isSelected(item) }"
          @click="selectOption(item)"
        >
          <img
            :src="item.item.image ? item.item.image : require('@/assets/images/placeholder/placeholder_image.png')"
            class="option-image"
          >

          <div class="option-content">
            <h5 class="option-title">
              {{ item.item ? item.item.name : '' }}
            </h5>
            <p class="option-sub">
              {{ item.item ? item.item.sku : '-' }}
            </p>
          </div>
        </div>
      </div>

      <div class="d-flex justify-content-end mt-2">
        <b-button
          variant="outline-secondary"
          class="mr-1"
          @click="$bvModal.hide('modal-edit-selected-option')"
        >
          Cancel
        </b-button>

        <b-button
          variant="success"
          :disabled="selectedOptionTemp.length == 0"
          @click="saveSelectedOption"
        >
          Save Changes
        </b-button>
      </div>
    </b-modal>
    <b-modal
      id="modal-update-validuntil-all-entitlement"
      ref="update-status-modal"
      modal-class="status-update-modal"
      cancel-variant="flat-primary"
      ok-variant="success"
      ok-title="Update"
      cancel-title="Cancel"
      centered
      no-close-on-backdrop
      title="Edit Validity"
      @ok="submitForm"
    >
      <b-form @submit.prevent="submitForm">
        <validation-observer
          ref="entitlementValidUntilEditForm"
        >
          <b-form-group
            label="Valid Until*"
            label-for="h-entitlement-validUntil"
          >
            <validation-provider
              #default="{ errors }"
              name="Valid Until"
              vid="validUntil"
              rules="required"
            >
              <b-input-group>
                <flat-pickr
                  id="h-validUntil"
                  v-model="validUntil"
                  class="form-control flat-pickr-group"
                  placeholder="Valid Until"
                  :config="flatPickrConfig"
                  @input="validUntilValidation == true ? validUntilValidation = false : null"
                />
                <b-input-group-append is-text>
                  <feather-icon
                    icon="CalendarIcon"
                    class="cursor-pointer"
                    data-toggle
                    size="18"
                  />
                </b-input-group-append>
              </b-input-group>
              <small class="text-danger">{{ errors[0] }}</small>
              <small
                v-if="validUntilValidation"
                class="text-danger"
              >
                {{ validUntilError }}
              </small>
            </validation-provider>
          </b-form-group>
        </validation-observer>
      </b-form>
    </b-modal>
    <b-modal
      id="modal-update-remarks-all-entitlement"
      ref="update-remarks-modal"
      modal-class="status-update-modal"
      cancel-variant="flat-primary"
      ok-variant="success"
      ok-title="Update"
      cancel-title="Cancel"
      centered
      no-close-on-backdrop
      title="Update Internal Remarks"
      @ok="submitRemarksForm"
    >
      <b-form @submit.prevent="submitRemarksForm">
        <validation-observer
          ref="entitlementRemarksEditForm"
        >
          <b-form-group
            label="Internal Remarks*"
            label-for="h-entitlement-status"
          >
            <validation-provider
              #default="{ errors }"
              name="Status"
              vid="status"
              rules="required"
            >
              <b-form-textarea
                id="h-remarks"
                v-model="internalRemarks"
                placeholder="Internal Remarks"
                :state="(errors.length > 0 || remarksValidation) ? false : null"
                name="remarks"
              />
              <small class="text-danger">{{ errors[0] }}</small>
              <small
                v-if="remarksValidation"
                class="text-danger"
              >
                {{ remarksError }}
              </small>
            </validation-provider>
          </b-form-group>
        </validation-observer>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BCard, BRow, BButton, BCol, BTableSimple, BTbody, BTr, BTh, BThead, BTd, VBTooltip, BForm, BFormGroup, BFormInput, BTab, BTabs, BCardText, BDropdown, BDropdownItem,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Ripple from 'vue-ripple-directive'
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'
import 'array.prototype.move'
import store from '@/store/index'
import { required } from '@validations'
import { useUtils as useAclUtils } from '@/libs/acl/custom'
import flatPickr from 'vue-flatpickr-component'
import '@core/scss/vue/libs/vue-flatpicker.scss'

const { canViewThisAction } = useAclUtils()

export default {
  components: {
    BCard,
    BRow,
    BButton,
    BCol,
    BTab,
    BTabs,
    BTableSimple,
    BTbody,
    BTr,
    BTh,
    BThead,
    BTd,
    BForm,
    BFormGroup,
    BFormInput,
    BCardText,
    BDropdown,
    BDropdownItem,

    ValidationProvider,
    ValidationObserver,
    flatPickr,
    AppTimeline,
    AppTimelineItem,
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  data() {
    return {
      entitlementID: '',
      inventoryOptions: [],
      selectedOptionTemp: [],
      topSpacing: 135,
      canViewThisAction,
      entitlement: {},
      entitlementDetailActivityLogs: [],
      status: '',
      redeemUntil: '',
      statusValidation: false,
      statusError: 'Valid status is required',
      name: '',
      validUntil: '',
      validUntilValidation: false,
      validUntilError: 'Valid status is required',
      internalRemarks: '',
      remarksValidation: false,
      remarksError: 'Internal Remarks is required',
      statusDataOptions: [
        { title: 'Redeemable', code: 'redeemable' },
        { title: 'Redeemed', code: 'redeemed' },
        { title: 'Used', code: 'used' },
        { title: 'Expired', code: 'expired' },
        { title: 'Cancelled', code: 'cancelled' },
      ],
      redemptionCode: ['', '', '', '', '', '', '', ''],
      redemptionCodeError: '',
      countdown: 0,
      countdownInterval: null,
      flatPickrConfig: {
        wrap: true, enableTime: false, dateFormat: 'd/m/Y', disableMobile: true,
      },
      required,
    }
  },
  computed: {
    formattedCountdown() {
      const minutes = Math.floor(this.countdown / 60)
      const seconds = this.countdown % 60

      return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')} mins left`
    },
    isExpired() {
      return this.countdown <= 0
    },
  },
  created() {
    this.getEntitlementScheme()
  },

  methods: {
    resolveTypeValue(type) {
      if (type === 1) return 'Inventory-managed item'
      if (type === 2) return 'Funeral Service Package'
      if (type === 3) return 'Non-inventory-managed item'
      return ''
    },
    undoRedemption(id) {
      this.$swal({
        title: 'Undo Redemption?',
        html: 'Are you sure you want to undo redemption this entitlement? This action cannot be undone.',
        // eslint-disable-next-line global-require
        imageUrl: require('@/assets/images/icons/wind.png'),
        reverseButtons: true,
        showCancelButton: true,
        cancelButtonText: 'No, go back',
        confirmButtonText: 'Yes, undo redemption',
        customClass: {
          confirmButton: 'btn btn-primary ml-1',
          cancelButton: 'btn btn-outline-primary',
        },
        buttonsStyling: false,
      })
        .then(async result => {
          if (result.value) {
            this.updateStatus(id, 'redeemable')
          }
        })
    },
    markAsRedeemable(id) {
      this.$swal({
        title: 'Mark as Redeemable?',
        html: 'Are you sure you want to redeemable this entitlement? This action cannot be undone.',
        // eslint-disable-next-line global-require
        imageUrl: require('@/assets/images/icons/wind.png'),
        reverseButtons: true,
        showCancelButton: true,
        cancelButtonText: 'No, go back',
        confirmButtonText: 'Yes, redeemable',
        customClass: {
          confirmButton: 'btn btn-primary ml-1',
          cancelButton: 'btn btn-outline-primary',
        },
        buttonsStyling: false,
      })
        .then(async result => {
          if (result.value) {
            this.updateStatus(id, 'redeemable')
          }
        })
    },
    markAsRedeemed(id) {
      this.$swal({
        title: 'Mark as Redeemed?',
        html: 'Are you sure you want to redeemed this entitlement? This action cannot be undone.',
        // eslint-disable-next-line global-require
        imageUrl: require('@/assets/images/icons/wind.png'),
        reverseButtons: true,
        showCancelButton: true,
        cancelButtonText: 'No, go back',
        confirmButtonText: 'Yes, redeemed',
        customClass: {
          confirmButton: 'btn btn-primary ml-1',
          cancelButton: 'btn btn-outline-primary',
        },
        buttonsStyling: false,
      })
        .then(async result => {
          if (result.value) {
            this.updateStatus(id, 'redeemed')
          }
        })
    },
    markAsCancelled(id) {
      this.$swal({
        title: 'Mark as Cancelled?',
        html: 'Are you sure you want to cancelled this entitlement? This action cannot be undone.',
        // eslint-disable-next-line global-require
        imageUrl: require('@/assets/images/icons/wind.png'),
        reverseButtons: true,
        showCancelButton: true,
        cancelButtonText: 'No, go back',
        confirmButtonText: 'Yes, Cancel',
        customClass: {
          confirmButton: 'btn btn-primary ml-1',
          cancelButton: 'btn btn-outline-primary',
        },
        buttonsStyling: false,
      })
        .then(async result => {
          if (result.value) {
            this.updateStatus(id, 'cancelled')
          }
        })
    },
    changeRoute(param) {
      this.$router.replace({
        params: {
          type: param,
        },
        query: {},
      })
    },
    isSelected(item) {
      return this.selectedOptionTemp.some(i => (i.inventoryItemId?._id || i.item._id) === item.item._id)
    },
    selectOption(item) {
      const id = item.item._id

      const index = this.selectedOptionTemp.findIndex(i => (i.inventoryItemId?._id || i.item?._id) === id)

      if (index !== -1) {
        // 🔴 already selected → remove (deselect)
        this.selectedOptionTemp.splice(index, 1)
      } else {
        // 🟢 not selected → add
        this.selectedOptionTemp.push(item)
      }
    },
    saveSelectedOption() {
      const payload = {
        selectedOptions: this.selectedOptionTemp.map(item => ({
          inventoryItemId: item.item ? item.item._id : item.inventoryItemId._id,
          quantity: item.quantity || 1,
          store: item.store || null,
        })),
      }

      this.$http.patch(
        `customer/entitlements/${this.$route.params.id}/selected-options/update`,
        payload,
      )
        .then(() => {
          this.getEntitlementScheme()
          this.$bvModal.hide('modal-edit-selected-option')
        })
    },
    openEditSelectedOption() {
      this.selectedOptionTemp = this.entitlement.selectedOptions.map(i => ({ ...i }))
      this.$bvModal.show('modal-edit-selected-option')
    },
    stopCountdown() {
      if (this.countdownInterval) {
        clearInterval(this.countdownInterval)
        this.countdownInterval = null
      }
    },
    startCountdown() {
      this.stopCountdown()
      if (!this.redeemUntil) {
        this.countdown = 0
        return
      }

      const expiryTime = new Date(this.redeemUntil).getTime()

      const updateCountdown = () => {
        const now = Date.now()
        const remaining = Math.floor((expiryTime - now) / 1000)

        this.countdown = remaining > 0 ? remaining : 0

        if (remaining <= 0) {
          this.stopCountdown()
        }
      }

      updateCountdown()

      this.countdownInterval = setInterval(() => {
        updateCountdown()
      }, 1000)
    },
    proceedToRedeem() {
      this.$http.patch(`customer/entitlements/${this.$route.params.id}/proceed-to-redeem`)
        .then(response => {
          this.redeemUntil = response.data.expiresAt
          if (this.redeemUntil) {
            this.startCountdown()
          }
          this.$bvModal.show('modal-redemption-code')
        })
    },
    handlePaste(event) {
      event.preventDefault()

      const pastedData = (event.clipboardData || window.clipboardData)
        .getData('text')
        .replace(/\D/g, '')
        .slice(0, 8)

      if (!pastedData) return

      pastedData.split('').forEach((char, index) => {
        this.$set(this.redemptionCode, index, char)
      })
    },

    handleInput(index, event) {
      const value = event.target.value.replace(/\D/g, '')

      this.$set(this.redemptionCode, index, value)

      if (this.redemptionCodeError) this.redemptionCodeError = ''

      // auto focus next input
      if (value && index < 7) {
        const inputs = this.$el.querySelectorAll('.code-input')

        if (inputs[index + 1]) {
          inputs[index + 1].focus()
        }
      }
    },
    redeemEntitlement() {
      const code = this.redemptionCode.join('')
      // Basic validation before calling API
      if (code.length < 8) {
        this.redemptionCodeError = 'Please enter the complete 8-digit redemption code.'
        return
      }

      this.redemptionCodeError = ''
      const formData = new FormData()
      formData.append('status', 'redeemed')
      formData.append('statusType', 'code')
      formData.append('code', code)

      this.$http.patch(`customer/entitlements/${this.$route.params.id}/redeem/update`, formData)
        .then(() => {
          this.$bvModal.hide('modal-redemption-code')
          this.getEntitlementScheme()
          this.$swal({
            title: 'Item has been redeemed',
            html: '',
            // eslint-disable-next-line global-require
            imageUrl: require('@/assets/images/icons/save.png'),
            imageWidth: 80,
            imageHeight: 80,
            imageAlt: 'Custom Icon',
            showCancelButton: false,
            confirmButtonText: 'Okay',
            customClass: {
              confirmButton: 'btn btn-primary',
            },
            buttonsStyling: false,
          })
        })
        .catch(error => {
          if (error.data.errors) {
            error.data.errors.forEach(() => {
              const codeError = error.data.errors.find(e => e.param === 'code')
              if (codeError) {
                this.redemptionCodeError = codeError.msg
              }
            })
          } else {
            this.redemptionCodeError = error.data?.message ?? 'Invalid redemption code. Please try again.'
          }
        })

      // Example: 12345678
    },
    getVariant(key) {
      if (key % 4 === 0) return 'info'
      if (key % 4 === 1) return 'warning'
      if (key % 4 === 2) return 'danger'
      if (key % 4 === 3) return 'purple'
      return 'primary'
    },
    resolveStatusVariant(status) {
      if (status === 'redeemable') return 'success'
      if (status === 'redeemed') return 'primary'
      if (status === 'used') return 'primary'
      if (status === 'expired') return 'secondary'
      if (status === 'cancelled') return 'danger'
      return 'primary'
    },

    getEntitlementScheme() {
      this.$http.get(`customer/entitlements/${this.$route.params.id}/show`)
        .then(response => {
          this.entitlement = response.data.entitlement || {}
          this.inventoryOptions = response.data.schemeItem?.inventoryOptions ?? []
          this.status = this.entitlement.status
          store.commit('breadcrumb/REMOVE_BREADCRUMB')
          const newMeta = {
            active: true,
            text: `${this.entitlement.name}`,
          }
          store.commit('breadcrumb/UPDATE_BREADCRUMB', newMeta)
          this.entitlementDetailActivityLogs = this.entitlement.activityLog.sort((a, b) => new Date(b.time) - new Date(a.time))
        })
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: error.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    },
    setEntitlement(item) {
      this.entitlementID = item._id
      this.validUntil = item.validUntil
      this.name = item.name
    },
    setEntitlementRemarks(item) {
      this.entitlementID = item._id
      this.internalRemarks = item.internalRemarks
      this.name = item.name
    },
    submitForm() {
      this.$refs.entitlementValidUntilEditForm.validate().then(success => {
        if (success) {
          const formData = new FormData()
          formData.append('validUntil', this.validUntil)

          this.$http.patch(`customer/entitlements/${this.entitlementID}/validity/update`, formData)
            .then(() => {
              this.$emit('emitCountEntitlement')
              this.$swal({
                title: 'Validity Updated!',
                html: `The validity for <strong>‘${this.name}’</strong> has been updated`,
                // eslint-disable-next-line global-require
                imageUrl: require('@/assets/images/icons/save.png'),
                imageWidth: 80,
                imageHeight: 80,
                imageAlt: 'Custom Icon',
                showCancelButton: false,
                confirmButtonText: 'Okay',
                customClass: {
                  confirmButton: 'btn btn-primary',
                },
                buttonsStyling: false,
              })
            })
            .catch(error => {
              if (error.data.errors) {
                error.data.errors.forEach(validationError => {
                  if (validationError.param === 'validUntil') {
                    this.validUntilError = validationError.msg
                    this.validUntilValidation = true
                  }
                })
              } else {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: error.data.message ?? process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                  },
                })
              }
            })
        }
      })
    },
    updateStatus(entitlementID, status) {
      const formData = new FormData()
      formData.append('status', status)

      this.$http.patch(`customer/entitlements/${entitlementID}/status/update`, formData)
        .then(() => {
          this.$emit('emitCountEntitlement')
          this.$swal({
            title: 'Status Updated!',
            html: `The status for <strong>‘${this.name}’</strong> has been updated`,
            // eslint-disable-next-line global-require
            imageUrl: require('@/assets/images/icons/save.png'),
            imageWidth: 80,
            imageHeight: 80,
            imageAlt: 'Custom Icon',
            showCancelButton: false,
            confirmButtonText: 'Okay',
            customClass: {
              confirmButton: 'btn btn-primary',
            },
            buttonsStyling: false,
          })
        })
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: error.data.message ?? process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    },
    submitRemarksForm() {
      this.$refs.entitlementRemarksEditForm.validate().then(success => {
        if (success) {
          const formData = new FormData()
          formData.append('internalRemarks', this.internalRemarks)

          this.$http.patch(`customer/entitlements/${this.entitlementID}/internal-remarks/update`, formData)
            .then(() => {
              this.$emit('emitCountEntitlement')
              this.$swal({
                title: 'Internal Remarks Updated!',
                html: `The internal remarks for <strong>‘${this.name}’</strong> has been updated`,
                // eslint-disable-next-line global-require
                imageUrl: require('@/assets/images/icons/save.png'),
                imageWidth: 80,
                imageHeight: 80,
                imageAlt: 'Custom Icon',
                showCancelButton: false,
                confirmButtonText: 'Okay',
                customClass: {
                  confirmButton: 'btn btn-primary',
                },
                buttonsStyling: false,
              })
            })
            .catch(error => {
              if (error.data.errors) {
                error.data.errors.forEach(validationError => {
                  if (validationError.param === 'internalRemarks') {
                    this.remarksError = validationError.msg
                    this.remarksValidation = true
                  }
                })
              } else {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: error.data.message ?? process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                  },
                })
              }
            })
        }
      })
    },
  },
}
</script>

<style lang="scss">
.display-content {
  display: contents;
}

.custom-th-width {
  .table th {
      padding: 0.72rem 2rem 0.72rem 0.72rem;
  }
}
.redemption-code-group {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-bottom: 20px;
}

.code-input {
  width: 48px;
  height: 48px;
  text-align: center;
  font-size: 20px;
  border-radius: 6px;
  border: 1px solid #d8d8d8;

  &:focus {
    border-color: #0052cc;
    box-shadow: none;
  }
}
.code-wrapper {
  display: flex;
  align-items: center;
}
.clock-icon {
  color: #f59e0b;
}
.redemption-wrapper {
  position: relative;
}

.modal-close-btn,
.close {
  position: relative;
  z-index: 9999;
}
.inventory-option-card.active {
  border: 2px solid #28c76f;
  background-color: rgba(40, 199, 111, 0.1);
}
.user_block.low-width {
  max-width: 66px;
  min-width: 66px;
  width: 66px;
  overflow: visible;
}
.user_block.low-width ul {
    left: auto !important;
    right: 0 !important;
}

.user_block.low-width button {
    width: 66px !important;
}

.btn-primary-dropdown a:hover {
  background-color: #104D9D !important;
  color: #fff !important;
}
</style>
